let ChangeCategoryService = function ($http) {

    var changeCategoryArray = [];

    /**
     * Get the list of care types
     */

    let data = function () {
        if (changeCategoryArray.length === 0) {
            changeCategoryArray = $http.get(WEBSERVICEURL + '/dataagility/api/service.changecategory/')
                .then(function (response) {
                    return response.data;
                });
        }

        return changeCategoryArray;
    }

    return { data };

};

export default ChangeCategoryService;



// WEBPACK FOOTER //
// ./client/app/common/services/changeCategory.service.js